import type { LineI } from "tweenly"
import Filters from "./ExpandableSections/Filters"
import LineStroke from "./ExpandableSections/LineStroke"
import Appearance from "./ExpandableSections/Appearance"
import SizeAndPosition from "./ExpandableSections/SizeAndPosition"
import TextColor from "./ExpandableSections/TextColor"
import Transforms from "./ExpandableSections/Transforms"

interface Props {
    object: LineI
    handleSetStyleValue: (property: any, value: any) => void
    handleSetObjectValue: (property: any, value: any) => void
}

// A line has no fill, border or corner radius — its look is the stroke and its color
const LineTools = ({ object, handleSetStyleValue, handleSetObjectValue }: Props) => {
    return (
        <div>
            <SizeAndPosition object={object} handleSetValue={handleSetStyleValue} />
            <Appearance object={object} handleSetValue={handleSetStyleValue} />
            <LineStroke
                object={object}
                handleSetStyleValue={handleSetStyleValue}
                handleSetObjectValue={handleSetObjectValue}
            />
            <TextColor object={object} handleSetValue={handleSetStyleValue} />

            <Filters object={object} handleSetObjectValue={handleSetObjectValue} />

            <Transforms
                object={object}
                handleSetStyleValue={handleSetStyleValue}
                handleSetObjectValue={handleSetObjectValue}
            />
        </div>
    )
}

export default LineTools
